import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { API } from '../../api/api'
import { ProjectSelectionType } from '../../types/index'
import BaseGhostButton from '../general/BaseGhostButton'
import BaseHeadline from '../general/BaseHeadline'
import BaseLabel from '../general/BaseLabel'

type ProjectGridSectionProps = ProjectSelectionType & {
    showPortfolioCta?: boolean
    className?: string
}

export default function ProjectGridSection({
    heading,
    projects,
    className,
    showPortfolioCta = false,
}: ProjectGridSectionProps) {
    const navigate = useNavigate()

    const gridColumnsClass =
        projects.length === 2
            ? 'lg:grid-cols-2'
            : projects.length >= 3
                ? 'lg:grid-cols-3'
                : 'lg:grid-cols-1'

    return (
        <section className={`py-20 px-4 w-full sm:px-8 xl:px-32  mx-auto ${className}`}>
            <div className="w-full">
                <div className='flex justify-between gap-4 pb-8 items-end'>
                    <BaseHeadline
                        label={heading?.label}
                        headline={heading?.headline}
                        text={heading?.text}
                        width='w-fit'
                    />
                    {showPortfolioCta && <BaseGhostButton text={'Alle Projekte ansehen'} url={'/portfolio'} classProps='mb-4' />}
                </div>
                <div className={`grid grid-cols-1 ${gridColumnsClass} gap-16`}>
                    {projects.map((project, index) => {
                        const previewImageUrl = project.previewImage?.data?.attributes?.url
                        const screenshotUrl = project.screenshot?.data?.attributes?.url
                        const imageUrl = previewImageUrl ?? screenshotUrl

                        return (
                            <div
                                key={project.id}
                                className='group cursor-pointer lg:opacity-70 hover:opacity-100 transition-opacity duration-300'
                                onClick={project.hasDetailPage ? () => navigate(`/portfolio/${project.id}#_`) : undefined}
                            >
                                {imageUrl &&
                                    <div className='h-[300px sm:h-[500px] lg:h-[300px] overflow-hidden border border-base-300/60 rounded-md'>
                                        <img className='h-full w-full object-cover group-hover:scale-105 transition-transform duration-300' src={API.img + imageUrl} alt={project.label} />
                                    </div>
                                }
                                <div className='pt-4 flex items-start gap-3'>
                                    <div className='flex flex-col min-w-0 flex-1'>
                                        <BaseLabel label={project.sublabel} classProps='block' color={index % 2 === 0 ? 'primary' : 'secondary'} />
                                        <BaseHeadline headline={project.label} width='w-fit' tag='h4' headlineClassProps='uppercase' />
                                    </div>
                                    {project.hasDetailPage && <ArrowRight strokeWidth={1} className={`w-8 h-8 shrink-0 mt-0.5 -rotate-45 group-hover:rotate-0 transition-transform duration-300 ${index % 2 === 0 ? 'group-hover:text-primary' : 'group-hover:text-secondary'}`} />}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
